import React, { useEffect, useState, useMemo, useRef } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tabs,
  message,
  Typography,
  Alert,
  InputNumber,
} from "antd";
import Seriales from "./components/Seriales";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createItem,
  readItems,
  readUsers,
  updateItem,
  updateUser,
} from "@directus/sdk";
import PorCaja from "./components/PorCaja";
import PorCajaGrupo from "./components/PorCajaGrupo";
import moment from "moment"; // Replace dayjs import with moment
import CajaCloseModal from "./components/CajaCloseModal";
import ConsignacionModal from "./components/ConsignacionModal";
import { getInventarioNSPrestamosByVendedor, updateInventarioNSPrestamo } from "../../services/inventarioNSPrestamos";
import { EditInventarioNoSerial, getInventarioNoSerialById, getInventarioNoSerialByProducto } from "../../services/inventarioNoSerial";
import { getProductosActivos } from "../../services/productos";
import { formatPrice } from "../../lib/utils";

const { Option } = Select;
const { Text } = Typography;

function Factura(props) {
  const dispacth = useDispatch();
  const [productos, setProductos] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });

  const [totalfactura, setTotalfactura] = useState(0);
  const [productotabla, setProductotabla] = useState([]);
  const [precios, setPrecios] = useState([]);
  const signoMoneda = useSelector((state) => state.signoMoneda.signo_moneda);
  const user = useSelector((state) => state.userdata.id);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const [currentCajaId, setCurrentCajaId] = useState(null);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const [precioselect, setPrecioselect] = useState(0);
  const [productoselect, setProductoselect] = useState({});

  const [seriales, setSeriales] = useState([]);
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [cajaAbierta, setCajaAbierta] = useState(false);

  // Add new state for final total
  const [totalConImpuestos, setTotalConImpuestos] = useState(0);

  // Add new state for clients
  const [clientes, setClientes] = useState([]);

  // Add new state at the top of the component
  const [tipoFactura, setTipoFactura] = useState([]);
  const [selectedTipoFactura, setSelectedTipoFactura] = useState(null);

  // Add new state for storing complete client data
  const [selectedClient, setSelectedClient] = useState(null);

  // Add new state for the modal
  const [isCajaCloseModalVisible, setIsCajaCloseModalVisible] = useState(false);

  // Add new state for discounts
  const [descuentos, setDescuentos] = useState([]);

  // Add new state for consignacion modal
  const [isConsignacionModalVisible, setIsConsignacionModalVisible] =
    useState(false);

  // Add new state for cantidad de productos no serializados
  const [cantidadNoSerializado, setCantidadNoSerializado] = useState(1);

  const [loading, setLoading] = useState(false);

  // Usar useRef para el array de productos a facturar (no se guarda en memoria entre renders)
  const arrayproductosfacturarRef = useRef([]);

  // Add new function to fetch clients
  const consultarClientes = async (value) => {
    if (!value) return; // If empty search, keep showing initial data

    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readUsers({
          search: value,
          fields: ["id", "first_name", "last_name"],
          filter: {
            role: {
              name: {
                _contains: "cliente",
              },
            },
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                    bodega: {
                      id: { _eq: userBodega },
                    },
                }
              : {}),
          },
        })
      );
      setClientes(response);
    } catch (error) {
      console.error("Error fetching clients:", error);
      message.error("Error al cargar los clientes");
    }
  };

  // Add this as a separate function
  const handleCajaValidation = (cajas) => {
    if (!cajas || cajas.length === 0) {
      Modal.confirm({
        title: "Caja Cerrada",
        content: "¿Desea abrir su caja para el día de hoy?",
        okText: "Sí, abrir caja",
        cancelText: "No",
        onOk: () => handleCajaOpen(),
        onCancel: () => setCajaAbierta(false),
      });
      return;
    }

    const cajaActual = cajas[0];
    const cajaDate = moment(cajaActual.fecha_apertura).startOf("day");
    const today = moment().startOf("day");

    if (cajaDate.isBefore(today)) {
      Modal.confirm({
        title: "Caja Anterior Abierta",
        content: "Tiene una caja abierta del día anterior. ¿Desea cerrarla?",
        okText: "Cerrar caja anterior",
        cancelText: "Cancelar",
        onOk: async () => {
          try {
            const directus = await getDirectusClient();
            await directus.request(
              updateItem("cajas", cajaActual.id, {
                estado: 2,
                fecha_cierre: moment().toISOString(),
              })
            );

            message.success("Caja anterior cerrada exitosamente");
            Modal.confirm({
              title: "Abrir Nueva Caja",
              content: "¿Desea abrir su caja para el día de hoy?",
              okText: "Sí, abrir caja",
              cancelText: "No",
              onOk: () => handleCajaOpen(),
              onCancel: () => setCajaAbierta(false),
            });
          } catch (error) {
            console.error("Error cerrando caja anterior:", error);
            Modal.error({
              title: "Error",
              content: "No se pudo cerrar la caja anterior",
            });
          }
        },
      });
      setCajaAbierta(false);
    } else {
      setCajaAbierta(true);
    }
  };

  // Simplify useEffect to only fetch data
  useEffect(() => {
    const fetchCajaStatus = async () => {
      try {
        const directus = await getDirectusClient();
        const response = await directus.request(
          readItems("cajas", {
            fields: ["id", "fecha_apertura", "fecha_cierre", "estado"],
            filter: {
              vendedor: {
                _eq: user,
              },
              estado: {
                _eq: 1,
              },
            },
            sort: ["-fecha_apertura"],
          })
        );
        if (response && response.length > 0) {
          setCurrentCajaId(response[0].id);
        }
        handleCajaValidation(response);
      } catch (error) {
        console.error("Error verificando caja:", error);
        Modal.error({
          title: "Error",
          content: "Error al verificar el estado de la caja",
        });
      }
    };

    if (user) {
      fetchCajaStatus();
    }
  }, [user]);

  // Add new useEffect to load initial clients
  useEffect(() => {
    const loadInitialClients = async () => {
      const directus = await getDirectusClient();
      try {
        const response = await directus.request(
          readUsers({
            fields: ["id", "first_name", "last_name"],
            filter: {
              role: {
                name: {
                  _contains: "cliente",
                },
              },
              ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
                ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                  }
                : {}),
            },
            limit: 100, // Adjust this number based on your needs
          })
        );
        setClientes(response);
      } catch (error) {
        console.error("Error loading initial clients:", error);
        message.error("Error al cargar los clientes iniciales");
      }
    };

    if (user) loadInitialClients();
  }, [user]); // Empty dependency array means this runs once when component mounts

  // Add new function to fetch tipo_factura
  const fetchTipoFactura = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("tipo_factura", {
          fields: ["id", "tipo"],
        })
      );
      setTipoFactura(response);
    } catch (error) {
      console.error("Error fetching tipo_factura:", error);
      message.error("Error al cargar los tipos de factura");
    }
  };

  // Add useEffect to load tipo_factura
  useEffect(() => {
    fetchTipoFactura();
  }, []);

  const handleCajaOpen = async () => {
    try {
      const directus = await getDirectusClient();
      const newCaja = await directus.request(
        createItem("cajas", {
          vendedor: user,
          fecha_apertura: moment().toISOString(),
          estado: 1,
          total_ventas: 0,
        })
      );

      if (newCaja) {
        setCurrentCajaId(newCaja.id);
        message.success("Caja abierta exitosamente");
        setCajaAbierta(true);
      }
    } catch (error) {
      console.error("Error abriendo caja:", error);
      Modal.error({
        title: "Error",
        content: "No se pudo abrir la caja",
      });
    }
  };

  // Add function to fetch discounts
  const fetchDescuentos = async (vendedorId) => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("descuentos", {
          fields: [
            "id",
            "nombre",
            "descuento",
            "productos.id",
            "productos.nombre",
            "usuarios.directus_users_id.id",
          ],
          filter: {
            usuarios: {
              directus_users_id: {
                id: { _eq: vendedorId },
              },
            },
          },
        })
      );
      setDescuentos(response);
      return response;
    } catch (error) {
      console.error("Error fetching discounts:", error);
      return [];
    }
  };

  // Cargar productos activos al inicio
  useEffect(() => {
    const cargarProductos = async () => {
      try {
        const productosActivos = await getProductosActivos();
        
        setProductos(productosActivos);
      } catch (error) {
        console.error("Error cargando productos:", error);
        message.error("Error al cargar los productos");
      }
    };

    cargarProductos();
    fetchDescuentos(user.id)
  }, []);

  // Limpiar productos de la factura cada vez que se selecciona un producto nuevo
  const limpiarFactura = () => {
    arrayproductosfacturarRef.current = [];
    setProductotabla([]);
    setTotalfactura(0);
    setTotalConImpuestos(0);
  };

  // Función para seleccionar producto
  const selecionadoproducto = async (ev) => {
    if (!ev) return;

    // Limpiar productos de la factura al seleccionar un producto nuevo
    limpiarFactura();

    const producto = productos.find((item) => item.id === ev);
    if (!producto) return;

    

    form.resetFields(["precios"]);
    setPrecioselect(0);

    // Verificar si el producto tiene seriales activos
    const tieneSeriales = producto.seriales && producto.seriales.some(serial => serial.estado?.id === 1);

    if (!tieneSeriales) {
      // Producto no serializado
      try {
        // Hacer la petición a getInventarioNoSerialById para obtener la cantidad y precio actualizados
        const inventario = await getInventarioNoSerialByProducto(producto.nombre);
        // inventario puede ser null si no hay stock en esa bodega
        let cantidadDisponible = 0;
        let precioNoSerial = parseFloat(producto.preciosinimp || 0);
        if (inventario.length > 0) {
          cantidadDisponible = parseInt(inventario[0].cantidad || 0);
          // Si el inventario tiene un precio diferente, usarlo
          if (inventario[0].producto.preciosinimp) {
            precioNoSerial = parseFloat(inventario[0].producto.preciosinimp);
          }
        }
        
        
        
        setProductoselect({
          ...producto,
          id: producto.id,
          nombre: producto.nombre,
          precio: precioNoSerial,
          cantidad: cantidadDisponible,
          esNoSerializado: true,
          grupo: {
            impuesto: producto.grupo?.impuesto || "0"
          }
        });

        setPrecios([{
          precio: precioNoSerial,
          alias: "precio",
          estado: true
        }]);
      } catch (err) {
        setProductoselect({
          ...producto,
          id: producto.id,
          nombre: producto.nombre,
          precio: parseFloat(producto.preciosinimp || 0),
          cantidad: 0,
          esNoSerializado: true,
          grupo: {
            impuesto: producto.grupo?.impuesto || "0"
          }
        });
        setPrecios([{
          precio: parseFloat(producto.preciosinimp || 0),
          alias: "precio",
          estado: true
        }]);
        message.error("No se pudo obtener el inventario no serializado para este producto.");
      }
    } else {
      // Producto serializado
      setProductoselect({ 
        ...producto, 
        esNoSerializado: false,
        precio: parseFloat(producto.preciosinimp || 0)
      });

      setPrecios([{
        precio: parseFloat(producto.preciosinimp || 0),
        alias: "precio",
        estado: true
      }]);

      // Cargar seriales activos para este producto
      await consultarseriales(producto.id);
    }
  };

  // Función para consultar seriales
  const consultarseriales = async (productoId) => {
    setLoading(true);
    try {
      
      const directus = await getDirectusClient();
      const countResponse = await directus.request(
        readItems("seriales", {
          filter: {
            _and: [
              {
                producto: {
                  id: { _eq: productoId },
                },
              },
              {
                estado: {
                  id: { _in: [1] },
                },
              },
              {
                ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
                  ? {
                      bodega: {
                        id: { _eq: userBodega },
                      },
                    }
                  : {}),
              },
            ],
          },
          aggregate: {
            countDistinct: ["id"],
          },
        })
      );
      const total = parseInt(countResponse[0]?.countDistinct?.id || 0);
      const response = await directus.request(
        readItems("seriales", {
          fields: [
            "bodega",
            "estado",
            "id",
            "caja",
            "user",
            "serial",
            "producto.grupo.impuesto",
            "producto.id",
            "producto.grupo.impuesto",
            "producto.nombre",
            "producto.preciosinimp",
          ],
          limit: pagination.pageSize,
          page: pagination.current,
          filter: {
            _and: [
              {
                producto: {
                  id: { _eq: productoId }
                }
              },
              {
                estado: {
                  id: { _eq: 1 }
                }
              },
              {
                ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
                  ? {
                    bodega: {
                      id: { _eq: userBodega }
                    }
                  }
                  : {})
              }
            ]
          }
        })
      );

      setSeriales(response);
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: total,
      }));
    } catch (error) {
      console.error("Error fetching seriales:", error);
      message.error("Error al cargar los seriales");
    } finally {
      setLoading(false);
    }
  };

  // Modify selectprecio function to correctly apply discounts
  const selectprecio = (ev) => {
    const newPrice = parseFloat(ev);
    setPrecioselect(newPrice);

    // Update only the current product's price
    if (productoselect && productoselect.id) {
      const existingProduct = arrayproductosfacturarRef.current.find(
        (item) => item.producto.id === productoselect.id
      );

      if (existingProduct) {
        existingProduct.precio = newPrice;
        // Find discount for this specific product
        const discount = descuentos.find(
          (d) => d.productos && d.productos.id === productoselect.id
        );

        if (discount) {
          existingProduct.descuento = parseFloat(discount.descuento);
        }
      }
    }

    updateTableData();
  };

  // Modify updateTableData function to correctly handle discounts
  const updateTableData = () => {
    
    
    // First map to process individual items
    const processedItems = arrayproductosfacturarRef.current.map((item) => {
      const discount = descuentos.find(
        (d) => d.productos && d.productos.id === item.producto.id
      );

      const impuesto = parseFloat(item.producto?.grupo?.impuesto || "0");
      const precio = parseFloat(item.precio || 0);
      const cantidad = item.esNoSerializado ? parseInt(item.cantidad || 0) : item.seriales.length;
      const descuentoPorcentaje = discount ? parseFloat(discount.descuento) : 0;
      
      const precioConDescuento = precio - (precio * descuentoPorcentaje / 100);
      const subtotal = precioConDescuento * cantidad;
      const totalConImpuesto = subtotal * (1 + impuesto / 100);

      return {
        key: item.producto.id,
        producto: item.producto.nombre,
        cantidad: cantidad,
        precio: precio,
        descuento: descuentoPorcentaje,
        precioConDescuento: precioConDescuento,
        impuesto: `${impuesto}%`,
        subtotal: subtotal,
        totalConImpuesto: totalConImpuesto,
        esNoSerializado: item.esNoSerializado
      };
    });

    // Group and combine items with same product ID
    const groupedItems = processedItems.reduce((acc, item) => {
      const existingItem = acc.find(i => i.key === item.key);
      
      if (existingItem) {
        // Sum quantities and recalculate totals
        existingItem.cantidad += item.cantidad;
        existingItem.subtotal += item.subtotal;
        existingItem.totalConImpuesto += item.totalConImpuesto;
      } else {
        acc.push(item);
      }
      
      return acc;
    }, []);



    const subtotal = groupedItems.reduce((sum, item) => sum + (item.subtotal || 0), 0);
    const totalFinal = groupedItems.reduce((sum, item) => sum + (item.totalConImpuesto || 0), 0);

    setTotalfactura(subtotal);
    setTotalConImpuestos(totalFinal);
    setProductotabla([...groupedItems]);
  };

  const addarray = async (array) => {
    await setProductotabla(array);
  };

  const agregarserial = (serial, checked, showMessage = true) => {
    if (!precioselect) {
      message.warning("Seleccione un precio primero");
      return;
    }

    // Check if serial is already selected in any product
    const isSerialAlreadySelected = arrayproductosfacturarRef.current?.some((item) =>
      item.seriales?.some((s) => s.id === serial.id)
    );

    if (checked && isSerialAlreadySelected) {
      message.warning("Este serial ya ha sido seleccionado");
      return;
    }

    if (checked) {
      let found = arrayproductosfacturarRef.current.find(
        (item) => item.producto.id === serial.producto.id
      );

      if (found) {
        const serialExists = found.seriales.find((item) => item.id === serial.id);
        if (!serialExists) {
          found.seriales.push(serial);
          if (showMessage) {
            message.success(
              `Se agregó el serial del producto ${found.producto.nombre}`
            );
          }
        }
      } else {
        const selectedProduct = productos.find(
          (p) => p.id === serial.producto.id
        );
        arrayproductosfacturarRef.current.push({
          producto: {
            id: serial.producto.id,
            nombre: selectedProduct?.nombre || serial.producto.nombre,
            grupo: {
              impuesto: selectedProduct?.grupo?.impuesto || "0"
            }
          },
          seriales: [serial],
          precio: parseFloat(precioselect) || 0,
          esNoSerializado: false
        });
        if (showMessage) {
          message.success(
            `Se agregó el serial del producto ${
              selectedProduct?.nombre || serial.producto.nombre
            }`
          );
        }
      }
    } else {
      // Handle unchecking a serial
      const productIndex = arrayproductosfacturarRef.current.findIndex(
        (item) => item.producto.id === serial.producto.id
      );

      if (productIndex !== -1) {
        const product = arrayproductosfacturarRef.current[productIndex];
        product.seriales = product.seriales.filter(s => s.id !== serial.id);

        // If no more serials for this product, remove the product from array
        if (product.seriales.length === 0) {
          arrayproductosfacturarRef.current.splice(productIndex, 1);
        }

        if (showMessage) {
          message.success(`Se eliminó el serial del producto ${product.producto.nombre}`);
        }
      }
    }

    updateTableData();
  };

  const items = [
    {
      key: "1",
      label: `Por Seriales`,
      children: (
        <Seriales
          productoselect={productoselect}
          seriales={seriales}
          setPagination={setPagination}
          current={pagination.current}
          totalpagina={pagination.total}
          agregarserial={agregarserial}
          onFetchSeriales={consultarseriales}
          loading={loading}
          arrayproductosfacturar={arrayproductosfacturarRef.current}
        />
      ),
    },
    {
      key: "2",
      label: `Por Caja`,
      children: (
        <PorCaja
          productoselect={productoselect}
          seriales={seriales}
          agregarPorCaja={agregarserial}
          onFetchSeriales={consultarseriales}
          loading={loading}
          arrayproductosfacturar={arrayproductosfacturarRef.current}
        />
      ),
    },
    {
      key: "3",
      label: `Por Caja y Grupo`,
      children: (
        <PorCajaGrupo
          productoselect={productoselect}
          seriales={seriales}
          agregarPorCajaGrupo={agregarserial}
          arrayproductosfacturar={arrayproductosfacturarRef.current}
        />
      ),
    },
  ];

  // Add a new function to handle product removal
  const handleRemoveProduct = (productId) => {
    const index = arrayproductosfacturarRef.current.findIndex(
      (item) => item.producto.id === productId
    );
    if (index > -1) {
      arrayproductosfacturarRef.current.splice(index, 1);
      updateTableData();
      message.success("Producto eliminado");
    }
  };

  // Modify columns array to show discount information
  const columns = [
    {
      title: "Producto",
      dataIndex: "producto",
      key: "producto",
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      key: "cantidad",
    },
    {
      title: "Precio",
      dataIndex: "precio",
      key: "precio",
      render: (value) => formatPrice(value,signoMoneda),
    },
    {
      title: "Descuento",
      dataIndex: "descuento",
      key: "descuento",
      render: (value) => (value ? `${value}%` : "0%"),
    },
    {
      title: "Precio con Descuento",
      dataIndex: "precioConDescuento",
      key: "precioConDescuento",
      render: (value) => formatPrice(value,signoMoneda),
    },
    {
      title: "Impuesto",
      dataIndex: "impuesto",
      key: "impuesto",
    },
    {
      title: "Subtotal",
      dataIndex: "subtotal",
      key: "subtotal",
      render: (value) => formatPrice(value,signoMoneda),
    },
    {
      title: "Total + Imp",
      dataIndex: "totalConImpuesto",
      key: "totalConImpuesto",
      render: (value) => formatPrice(value,signoMoneda),
    },
    {
      title: "Acciones",
      key: "action",
      render: (_, record) => (
        <Button
          type="text"
          danger
          onClick={() => handleRemoveProduct(record.key)}
        >
          Eliminar
        </Button>
      ),
    },
  ];

  // Add new helper function for credit validations

  const handleClienteChange = async (clienteId) => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          fields: [
            "id",
            "credito",
            "first_name",
            "last_name",
            "tope_credito",
            "credito_usado",
            "fecha_credito_acreditado",
            "dias_max_credito",
          ],
          filter: {
            id: { _eq: clienteId },
          },
        })
      );

      if (response && response[0]) {
        const clientData = response[0];
        setSelectedClient(clientData);

        form.setFieldsValue({ tipo_factura: undefined });
        setSelectedTipoFactura(null);

        if (!clientData.credito) {
          setSelectedTipoFactura(1);
          form.setFieldsValue({ tipo_factura: 1 });
          message.warning(
            "Este cliente no tiene crédito habilitado - solo facturas de cobro"
          );
          return;
        }

        // Check credit days if there's an active credit
        if (clientData.fecha_credito_acreditado) {
          const creditDate = moment(clientData.fecha_credito_acreditado);
          const daysElapsed = moment().diff(creditDate, "days");

          if (daysElapsed > clientData.dias_max_credito) {
            message.warning(
              `Cliente ha superado el límite de días de crédito (${clientData.dias_max_credito} días)`
            );
          }
        }

        // Check available credit
        const currentCreditUsed = parseFloat(clientData.credito_usado || 0);
        const creditLimit = parseFloat(clientData.tope_credito || 0);
        const availableCredit = creditLimit - currentCreditUsed;

        if (availableCredit <= 0) {
          message.warning("Cliente ha alcanzado su tope de crédito");
        } else {
          message.info(
            `Crédito disponible: $${availableCredit.toLocaleString()}`
          );
        }
      }
    } catch (error) {
      console.error("Error checking client credit:", error);
      message.error("Error al verificar el crédito del cliente");
    }
  };

  // Add credit validation function
  const validateCredit = async (clientData, invoiceAmount) => {
    // Check if client has credit enabled
    if (!clientData.credito) {
      throw new Error("Este cliente no tiene crédito habilitado");
    }

    // Check credit limit
    const currentCreditUsed = parseFloat(clientData.credito_usado || 0);
    const creditLimit = parseFloat(clientData.tope_credito || 0);
    const newCreditTotal = currentCreditUsed + invoiceAmount;

    if (newCreditTotal > creditLimit) {
      throw new Error(
        `El cliente superaría su tope de crédito (${creditLimit.toLocaleString()})`
      );
    }

    // Check credit days if there's an active credit
    if (clientData.fecha_credito_acreditado) {
      const creditDate = moment(clientData.fecha_credito_acreditado);
      const daysElapsed = moment().diff(creditDate, "days");

      if (daysElapsed > clientData.dias_max_credito) {
        throw new Error(
          `El cliente ha superado su límite de días de crédito (${clientData.dias_max_credito} días)`
        );
      }
    }

    return true;
  };

  // Update the Facturar function
  const Facturar = async () => {
    if (!precioselect) {
      message.warning("Debe seleccionar un precio antes de facturar");
      return;
    }

    try {
      if (!cajaAbierta) {
        Modal.error({
          title: "Caja Cerrada",
          content: "No puede crear facturas sin tener una caja abierta.",
        });
        return;
      }

      const formValues = form.getFieldsValue();
      

      const directus = await getDirectusClient();
      let productos = [];
      let allSeriales = [];
      let totalVenta = 0;
      const currentDate = moment().format("YYYY-MM-DDTHH:mm:ssZ");

      // Calculate total and prepare productos data
      arrayproductosfacturarRef.current.forEach((item) => {
        if (item.esNoSerializado) {
          totalVenta += item.precio * item.cantidad;
          productos.push({
            cantidad: item.cantidad,
            nombre: item.producto.nombre,
            precio_unitario: item.precio,
            producto: item.producto.id
          });
        } else {
          totalVenta += item.precio * item.seriales.length;
          productos.push({
            nombre: item.producto.nombre,
            cantidad: item.seriales.length,
            precio_unitario: item.precio,
            producto: item.producto.id,
            seriales: {
              create: [],
              update: item.seriales.map(serial => ({
                produtofactura: "+",
                id: serial.id
              })),
              delete: []
            }
          });
          allSeriales.push(...item.seriales.map((s) => s.id));
        }
      });

      if (formValues.tipo_factura === 2) {
        try {
          const directus = getDirectusClient();
          const clientResponse = await directus.request(
            readUsers({
              fields: [
                "id",
                "credito",
                "credito_usado",
                "tope_credito",
                "fecha_credito_acreditado",
                "dias_max_credito",
              ],
              filter: { id: { _eq: formValues.cliente } },
            })
          );

          const clientData = clientResponse[0];

          if (!clientData) {
            throw new Error("Cliente no encontrado");
          }

          await validateCredit(clientData, totalConImpuestos);
        } catch (error) {
          Modal.error({
            title: "Error de Crédito",
            content: error.message,
          });
          return;
        }
      }

      // Create factura regardless of type
      const facturaResponse = await directus.request(
        createItem("facturas", {
          
          vendedor_factura: user.id,
          cliente: formValues.cliente,
          tipo: formValues.tipo_factura,
          prefijo: "PRE",
          total: totalVenta,
          productos: {
            create: productos.map(producto => ({
              nombre: producto.nombre,
              cantidad: producto.cantidad,
              precio_unitario: producto.precio_unitario,
              producto: producto.producto,
              seriales: producto.seriales || undefined,
              esNoSerializado: producto.esNoSerializado || undefined
            }))
          },
          caja: currentCajaId,
          bodega: userBodega,
        })
      );

      if (facturaResponse.id) {
        // Update prestamo_usado for vendor
       

        if (formValues.tipo_factura === 2) {
          // Convert the values to numbers and calculate the new credit
          const currentCreditUsed = parseFloat(
            selectedClient.credito_usado || 0
          );
          const newCreditAmount = parseFloat(totalConImpuestos);
          const newCreditUsed = (currentCreditUsed + newCreditAmount).toFixed(
            2
          );

        
        }

        // Crear historial_seriales para productos serializados
        if (allSeriales.length > 0) {
          await directus.request(
            createItem("historial_seriales", {
              tipo: 1,
              factura_n: facturaResponse.id,
              seriales: {
                create: allSeriales.map((serialId) => ({
                  historial_seriales_id: "+",
                  seriales_id: {
                    id: serialId,
                  },
                })),
              },
            })
          );

          // Actualizar estado de seriales
          await Promise.all(
            allSeriales.map((serialId) =>
              directus.request(
                updateItem("seriales", serialId, {
                  estado: 2, // estado facturado
                  user: null, // Limpiar el usuario
                  factura: facturaResponse.id, // Asignar la factura
                })
              )
            )
          );
        }

        // Procesar productos no serializados
        const productosNoSerializados = arrayproductosfacturarRef.current.filter(item => item.esNoSerializado);
        if (productosNoSerializados.length > 0) {
          // Crear historial_seriales para productos no serializados
          const historialResponse = await directus.request(
            createItem("historial_seriales", {
              tipo: 1,
              factura_n: facturaResponse.id,
            })
          );

          // Procesar cada producto no serializado
          for (const item of productosNoSerializados) {
            // Buscar el inventario no serializado
            const inventarioNoSerial = await directus.request(
              readItems("inventario_no_serial", {
                fields: ["*"],
                filter: { producto: { id: { _eq: item.producto.id } } },
              })
            );

            if (inventarioNoSerial && inventarioNoSerial.length > 0) {
              const inventarioNsId = inventarioNoSerial[0].id;

              // Buscar el préstamo no serializado
              const prestamoNoSerial = await directus.request(
                readItems("inventario_ns_prestamo", {
                  fields: ["*"],
                  filter: {
                    _and: [
                      { inventario_ns: { id: { _eq: inventarioNsId } } },
                      { estado: { _eq: "prestado" } }
                    ]
                  }
                })
              );

              if (prestamoNoSerial && prestamoNoSerial.length > 0) {
                const prestamoId = prestamoNoSerial[0].id;
                const cantidadActual = prestamoNoSerial[0].cantidad;
                const cantidadAFacturar = item.cantidad;
                const nuevaCantidad = cantidadActual - cantidadAFacturar;

                await updateInventarioNSPrestamo(prestamoId, {
                  cantidad: nuevaCantidad
                });
                await EditInventarioNoSerial(inventarioNsId, {
                  cantidad: nuevaCantidad
                });

                // Crear detalle_historial_ns
                await directus.request(
                  createItem("detalle_historial_ns", {
                    cantidad: item.cantidad,
                    historial_seriales: {
                      create: [{
                        detalle_historial_ns_id: "+",
                        historial_seriales_id: { id: historialResponse.id }
                      }],
                    },
                    prestamo_ns_p: prestamoId
                  })
                );
              }
            }
          }
        }

        message.success("Factura creada exitosamente");
        // Limpiar productos de la factura después de facturar
        limpiarFactura();
        navigate("/visualizarfactura", {
          state: {
            factura: facturaResponse,
          },
        });
      }
    } catch (error) {
      console.error("Error creating factura:", error);
      Modal.error({
        title: "Error",
        content: "Error al crear la factura",
      });
    }
  };

  const cerrarCaja = () => {
    setIsCajaCloseModalVisible(true);
  };

  // Add this check before rendering tabs
  const showTabs = useMemo(() => {
    return productoselect.id && precioselect > 0;
  }, [productoselect.id, precioselect]);

  // Función para manejar la cantidad de productos no serializados
  const handleCantidadNoSerializado = (value) => {
    if (!productoselect || typeof productoselect.cantidad === "undefined") {
      message.warning("Debe seleccionar un producto primero");
      return;
    }

    const cantidadDisponible = parseInt(productoselect.cantidad);
    const cantidadSolicitada = parseInt(value);

    if (cantidadSolicitada > cantidadDisponible) {
      message.warning(`La cantidad no puede superar ${cantidadDisponible}`);
      return;
    }

    setCantidadNoSerializado(cantidadSolicitada);
  };

  // Función para agregar productos no serializados
  const agregarProductoNoSerializado = () => {
    if (!productoselect || !productoselect.id) {
      message.warning("Debe seleccionar un producto primero");
      return;
    }

    if (!precioselect || precioselect <= 0) {
      message.warning("Debe seleccionar un precio válido");
      return;
    }

    if (cantidadNoSerializado <= 0) {
      message.warning("La cantidad debe ser mayor a 0");
      return;
    }

    // Verificar si ya existe el producto en el array
    const productoExistente = arrayproductosfacturarRef.current.find(
      item => item.producto.id === productoselect.id && item.esNoSerializado
    );

    if (productoExistente) {
      const cantidadTotal = parseInt(productoExistente.cantidad) + parseInt(cantidadNoSerializado);
      if (cantidadTotal > parseInt(productoselect.cantidad)) {
        message.warning(`La cantidad total no puede superar ${productoselect.cantidad}`);
        return;
      }
      productoExistente.cantidad = cantidadTotal.toString();
    } else {
      arrayproductosfacturarRef.current.push({
        producto: {
          id: productoselect.id,
          nombre: productoselect.nombre,
          grupo: {
            impuesto: productoselect.grupo?.impuesto || "0"
          }
        },
        cantidad: cantidadNoSerializado.toString(),
        precio: precioselect,
        esNoSerializado: true
      });
    }

    updateTableData();
    message.success("Producto agregado correctamente");
  };

  useEffect(() => {
    if (productoselect?.id && !productoselect.esNoSerializado) {
      consultarseriales();
    }
  }, [pagination.current, productoselect?.id, productoselect?.esNoSerializado]);

  return (
    <Layouts>
      <Form form={form} onFinish={Facturar}>
        <Row gutter={16}>
          <Col>
            {" "}
            
            <Form.Item
              name="producto"
              label="Seleccione un producto"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un Producto"
                filterOption={false}
                onChange={selecionadoproducto}
                style={{ width: 200 }}
              >
                {productos.map((producto) => (
                  <Option key={producto.id} value={producto.id} allowClear>
                    {producto.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="precios"
              label="Seleccione precio de producto"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un Precio"
                showSearch={true}
                filterOption={false}
                onChange={selectprecio}
                style={{ width: 200 }}
              >
                {precios.map((precio) => (
                  <Option key={precio.alias} value={precio.precio}>
                    {`${precio.alias}: ${formatPrice(precio.precio,signoMoneda)}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Alert que aparece si no se ha seleccionado un precio */}
            {!precioselect && (
              <Alert
                message="Debe seleccionar un precio para continuar"
                type="warning"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}

            <Form.Item
              name="cliente"
              label="Cliente"
              rules={[
                { required: true, message: "Por favor seleccione un cliente" },
              ]}
            >
              <Select
                placeholder="Seleccione un cliente"
                showSearch
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onSearch={consultarClientes}
                onChange={handleClienteChange}
                style={{ width: 200 }}
              >
                {clientes.map((cliente) => (
                  <Option key={cliente.id} value={cliente.id}>
                    {`${cliente.first_name} ${cliente.last_name}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="tipo_factura"
              label="Tipo de Factura"
              rules={[
                {
                  required: true,
                  message: "Por favor seleccione el tipo de factura",
                },
              ]}
            >
              <Select
                placeholder="Seleccione el tipo de factura"
                value={selectedTipoFactura}
                onChange={(value) => setSelectedTipoFactura(value)}
                style={{ width: 200 }}
              >
                {tipoFactura.map((tipo) => {
                  const isDisabled =
                    tipo.tipo === "credito" && !selectedClient?.credito;

                  return (
                    <Option key={tipo.id} value={tipo.id} disabled={isDisabled}>
                      {tipo.tipo}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            {productoselect?.esNoSerializado ? (
              <Form.Item label="Cantidad">
                <InputNumber
                  min={1}
                  max={parseInt(productoselect.cantidad)}
                  value={cantidadNoSerializado}
                  onChange={handleCantidadNoSerializado}
                  style={{ width: 120 }}
                />
                <Button
                  type="primary"
                  onClick={agregarProductoNoSerializado}
                  style={{ marginLeft: 8 }}
                >
                  Agregar
                </Button>
              </Form.Item>
            ) : (
              // Mostrar Alert si no hay precio seleccionado, de lo contrario mostrar tabs
              !precioselect ? (
                <Alert
                  message="Seleccione un precio para habilitar las opciones de seriales"
                  type="warning"
                  showIcon
                  style={{ marginBottom: 16, width: '100%' }}
                />
              ) : (
                <Tabs defaultActiveKey="1" items={items} />
              )
            )}
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={productotabla}
          rowKey="key" // Add this line
          pagination={false} // Optional, depending on your needs
        />
        <Row justify="end" style={{ marginTop: 16 }}>
          <Col>
            <Space
              direction="vertical"
              size="small"
              style={{ textAlign: "right" }}
            >
              <Text>Subtotal: {formatPrice(totalfactura,signoMoneda)}</Text>
              <Text type="success">
                Total + Imp: {formatPrice(totalConImpuestos,signoMoneda)}
              </Text>
            </Space>
          </Col>
        </Row>
        <Space>
          <Button type="primary" htmlType="submit" disabled={!cajaAbierta}>
            Facturar
          </Button>
          <Button
            type="primary"
            onClick={() => setIsConsignacionModalVisible(true)}
            disabled={!cajaAbierta}
          >
            Nueva Consignación
          </Button>
          <Button onClick={cerrarCaja} disabled={!cajaAbierta} danger>
            Cerrar Caja
          </Button>
        </Space>
      </Form>
      <CajaCloseModal
        visible={isCajaCloseModalVisible}
        onClose={() => setIsCajaCloseModalVisible(false)}
        cajaId={currentCajaId}
        onCajaClosed={() => {
          setCajaAbierta(false);
          setCurrentCajaId(null);
        }}
      />
      <ConsignacionModal
        visible={isConsignacionModalVisible}
        onCancel={() => setIsConsignacionModalVisible(false)}
        currentCajaId={currentCajaId}
      />
    </Layouts>
  );
}

export default Factura;
